import axios from 'axios';

import { configSetting } from '../config';

export const publicFetch = axios.create({
  baseURL: configSetting.apiUrl,
});
